import ProcessUser from "@/types/documents/process/ProcessUser";
import { IDataProvider } from "@/store";

export interface IProcessUserState {
  processUser: ProcessUser | null;
  processUsers: ProcessUser[] | null;
  dataProvider: IDataProvider<ProcessUser> | null;
}

export const state: IProcessUserState = {
  processUser: null,
  processUsers: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
